// The components library paints its red variants with red-* stops, which the
// theme maps onto the tenant button color. A negative state must stay on the
// stock error ramp, so these ride on the className the library merges last;
// the svg selector outranks the class the library puts on the icon itself.
// ERROR_ALERT_CLASS carries no text color on purpose: the library puts
// text-red-900 on inner nodes, and red-900 stays stock.
export const ERROR_ALERT_CLASS =
  'border-error-200 bg-error-50 [&_svg]:!text-error-500';

export const ERROR_BADGE_CLASS = 'bg-error-100 text-error-800';

export const ERROR_STATUS_ICON_CLASS = 'bg-error-100 [&_svg]:!text-error-500';
